"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeParseFloat = exports.safeParseInt = void 0;
const intStrRegex = /^-?\d/;
const floatStrRegex = /^-?\.?\d/;
const safeParseInt = (s) => (!!s && intStrRegex.test(s) ? parseInt(s) : undefined);
exports.safeParseInt = safeParseInt;
const safeParseFloat = (s) => (!!s && floatStrRegex.test(s) ? parseFloat(s) : undefined);
exports.safeParseFloat = safeParseFloat;
